import { BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

export default function BadgeVerified({ className = "", label = "Verified" }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-semibold text-brand-ink shadow-hairline",
        className
      )}
    >
      <BadgeCheck size={12} strokeWidth={2.5} className="text-brand-lime" />
      {label}
    </span>
  );
}
